import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPage() {
  return (
    <div className="legal-page" data-testid="privacy-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          Back to Home
        </Link>
        
        <h1>Privacy and Policies</h1>
        <p className="legal-updated">Last Updated: February 2026</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            QMDJ.live ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. 
            This Privacy Policy explains how we collect, use, and safeguard your information when you use our Service.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Information We Collect</h2>
          <h3>2.1 Personal Information</h3>
          <p>When you register for an account, we may collect:</p>
          <ul>
            <li>Email address</li>
            <li>Name (optional)</li>
            <li>Account preferences</li>
          </ul>
          
          <h3>2.2 Usage Data</h3>
          <p>We automatically collect:</p>
          <ul>
            <li>Browser type and version</li>
            <li>Pages visited and time spent</li>
            <li>Date and time of access</li>
            <li>Device information</li>
          </ul>

          <h3>2.3 Uploaded Content</h3>
          <p>
            Chart images and data you upload to the Service are stored on our servers to provide you with the Service functionality.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and maintain the Service</li>
            <li>Process your account registration</li>
            <li>Send important notifications about the Service</li>
            <li>Improve and optimize the Service</li>
            <li>Respond to your inquiries and support requests</li>
            <li>Detect and prevent fraud or abuse</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Data Storage and Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. Your data is stored on secure 
            servers and we use encryption for data transmission. However, no method of electronic storage is 100% secure.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Data Sharing</h2>
          <p>We do not sell your personal information. We may share your data with:</p>
          <ul>
            <li>Service providers who assist in operating the Service</li>
            <li>Law enforcement when required by law</li>
            <li>Third parties with your explicit consent</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Cookies</h2>
          <p>
            We use cookies and similar technologies to enhance your experience. You can control cookie preferences through 
            your browser settings. Disabling cookies may affect Service functionality.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Data Retention</h2>
          <p>
            We retain your personal information for as long as your account is active or as needed to provide the Service. 
            You may request deletion of your account and associated data at any time.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Children's Privacy</h2>
          <p>
            The Service is not intended for users under 13 years of age. We do not knowingly collect personal information 
            from children under 13.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new 
            Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at privacy@qmdj.live
          </p>
        </section>

        <footer className="legal-footer">
          <p className="footer-copyright">Copyright © 2026 Steven Yong - Digital Dive Coaching Sdn. Bhd. All rights reserved worldwide.</p>
        </footer>
      </div>
    </div>
  );
}
